
  // Relays a <dialog> "close" to a LiveComponent (the sheet primitive's
  // on_close can only target the LiveView).
  export default {
    mounted() {
      const dialog = this.el.closest("dialog")
      if (!dialog) return
      this.dialog = dialog
      this.onClose = () => {
        const target = this.el.getAttribute("phx-target")
        const event = this.el.dataset.event
        if (target && event) this.pushEventTo(target, event, {})
      }
      dialog.addEventListener("close", this.onClose)
    },
    destroyed() {
      if (this.dialog && this.onClose) this.dialog.removeEventListener("close", this.onClose)
    },
  }
